export const getDatesDifferenceInYears = (dateA: Date, dateB: Date) => {
  const diff = Math.floor(new Date(dateA).getTime() - new Date(dateB).getTime());
  const day = 1000 * 60 * 60 * 24;
  return Math.floor(diff / day / 365);
};
